// ============================================================
// 卡牌系統 — 五套牌組原型（固定模板）
// ============================================================
// 結構：(4+4+4) 三種疊加 + (2+2) 兩種效果 + (1+1) 兩種濾牌 = 18
// 對接設計文件 §6。
// 未來開放「效果牌槽數可變 / 總量 14~24」時，放寬本表即可。
// ============================================================

import type { DeckArchetype } from './CardTypes.ts';

export const DECK_TEMPLATES: DeckArchetype[] = [
  {
    id: 'burn',
    name: '烈焰轟炸',
    blurb: '長草→火球 DOT + 加攻強化自走部隊，落石封路；搜牌穩定湊雙火爆發。',
    cards: { fireball: 4, lightning: 4, buffAtk: 4, grow: 2, rockfall: 2, tutor: 1, draw: 1 },
  },
  {
    id: 'storm',
    name: '沼澤雷擊',
    blurb: '降雨鋪積水→閃電吃加成；降雨打草→沼澤拖慢。補血護盾撐場，最吃預判自走路徑。',
    cards: { lightning: 4, heal: 4, shield: 4, rain: 2, grow: 2, tutor: 1, draw: 1 },
  },
  {
    id: 'bulwark',
    name: '鋼鐵壁壘',
    blurb: '無直傷，靠落石封鎖 + 旋風甩開貼臉 + 加攻自走部隊消耗，拖死對手。容錯最高。',
    cards: { shield: 4, heal: 4, buffAtk: 4, rockfall: 2, whirlFoe: 2, draw: 1, cycle: 1 },
  },
  {
    id: 'tempest',
    name: '風暴操控',
    blurb: '點燃/落石後旋風把敵人拉進去；旋風-友拉殘血己方回後方補血。上限最高、最吃位置。',
    cards: { fireball: 4, heal: 4, buffAtk: 4, whirlFoe: 2, whirlAlly: 2, tutor: 1, draw: 1 },
  },
  {
    id: 'starter',
    name: '元素均衡',
    blurb: '無搜牌、無強 combo 門檻，補血護盾雙厚容錯高，適合教學關。',
    cards: { fireball: 4, heal: 4, shield: 4, rain: 2, grow: 2, draw: 1, cycle: 1 },
  },
];

export function getDeckTemplate(id: string): DeckArchetype | undefined {
  return DECK_TEMPLATES.find((d) => d.id === id);
}
